import { render, staticRenderFns } from "./DoctorSidebar.vue?vue&type=template&id=7f3ad73a&scoped=true&"
import script from "./DoctorSidebar.vue?vue&type=script&lang=js&"
export * from "./DoctorSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DoctorSidebar.vue?vue&type=style&index=0&id=7f3ad73a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3ad73a",
  null
  
)

export default component.exports